module.exports = __webpack_public_path__ + "img/DSC02567.e278f632.jpeg";